export default {
    product: {},
    options: {}
} as any